import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function InsertPageBreakIcon(props: IconProps) {
    return <Icon {...props} iconKey={"insert_page_break"}/>
}
